export class CostReviewFireEnUsWiringResponsibilities {
  fieldTerminations!: number;
  panelTerminations!: number;
  padAndRemoteAnnunciator!: number;
  highVoltageWiring!: number;
  supply24Vdc!: number;
  thirdPartyTerminations!: number;
  fiberOpticsRequired!: number;
  fiberFurnishedBy!: number;
  fiberInstalledBy!: number;
  fiberTerminationsBy!: number;
  ductHousingsAndSampling!: number;
  providesPowerForEnclosureHeaters!: number;
  fireSmokeDamperValve!: number;
  powerForActuatorsFurnishedBy!: number;
  wireCablingFurnishedBy!: number;
  freeRunCableAcceptable!: number;
  isWiringResponsibilitiesApplicable!: boolean;
  powerWiring!: number;
  lowVoltageWiring!: number;
  devicesInstalled!: number;
  devicesWired!: number;
  equipmentInstalled!: number;
}
